import { createStore, applyMiddleware, Store } from "redux";
import thunk from "redux-thunk";
import { composeWithDevTools } from "redux-devtools-extension";
import reducers, { initialState, State } from "./reducers";

const composeEnhancers = composeWithDevTools({
  name: "tvg-mybets-desktop"
});

export default (state: State = initialState): Store<State> => {
  const middlewares = [thunk];
  const enhancer = composeEnhancers(applyMiddleware(...middlewares));

  // @ts-ignore
  const store = createStore(reducers, state, enhancer);

  // @ts-ignore
  if (module.hot) {
    // @ts-ignore
    module.hot.accept("./reducers", () =>
      import("./reducers").then((reducerModule) =>
        store.replaceReducer(reducerModule.default)
      )
    );
  }

  return store;
};
